<template>
  <v-app>
    <div class="scroll-wrapper">
      <section class="hero-sticky-wrapper">
        <Hero />
        <HomeMaintenancePackages />
        <Services />
      </section>
      <div class="scroll-content">
        <Contact />
        <Testimonials />
        <FaqSection />
        <!-- <BottomStatsSection /> -->
      </div>
    </div>
  </v-app>
</template>

<script>
import Testimonials from "@/components/Testimonials.vue";
import Services from "@/components/Services.vue";
import HomeMaintenancePackages from "@/components/HomeMaintenancePackages.vue";
import Contact from "@/components/Cta.vue";
import Hero from "@/components/Hero.vue";
import FaqSection from "@/components/Faq.vue";
// import BottomStatsSection from "../components/BottomStatsSection.vue";

export default {
  components: {
    Testimonials,
    Services,
    Contact,
    Hero,
    FaqSection,
    // BottomStatsSection,
    HomeMaintenancePackages,
  },
  data() {
    return {
      drawer: false,
      contactDialog: false,
      services: [
        {
          icon: "mdi-broom",
          title: "Commercial Deep Cleaning",
          description:
            "Scheduled, high-capacity cleaning and sanitization for office and retail spaces with certified eco-friendly products.",
          image:
            "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&q=80",
        },
        {
          icon: "mdi-pipe-wrench",
          title: "Infrastructure Plumbing",
          description:
            "Preventative and emergency plumbing solutions for large commercial and residential buildings.",
          image:
            "https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=800&q=80",
        },
        {
          icon: "mdi-air-conditioner",
          title: "Enterprise HVAC Services",
          description:
            "Managed climate control and air quality systems maintenance for critical business environments.",
          image:
            "https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=800&q=80",
        },
        {
          icon: "mdi-format-paint",
          title: "Industrial-Grade Painting",
          description:
            "Long-lasting interior and exterior coatings for high-traffic and industrial areas.",
          image:
            "https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=800&q=80",
        },
        {
          icon: "mdi-lightning-bolt",
          title: "Certified Electrical Works",
          description:
            "Code-compliant installations, repairs, and power management for corporate facilities.",
          image:
            "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=800&q=80",
        },
        {
          icon: "mdi-tools",
          title: "Facility Handyman Contracts",
          description:
            "Custom Service Level Agreements for ongoing facility repair and maintenance needs.",
          image:
            "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=800&q=80",
        },
      ],
      testimonials: [
        {
          name: "Global Tech Corp",
          location: "New York, NY",
          initial: "GT",
          text: "Their facility management contract is flawless. The 99.5% SLA adherence gives us complete peace of mind.",
        },
        {
          name: "Apex Property Mgmt",
          location: "Chicago, IL",
          initial: "AP",
          text: "OhYes Corp. manages all our high-end residential towers. Simply the best plumbing and HVAC teams in the business.",
        },
        {
          name: "Harbor Retail Group",
          location: "Houston, TX",
          initial: "HR",
          text: "Reliable, consistent, always on time. Complete electrical overhaul with zero downtime. Highly professional service.",
        },
      ],
    };
  },
  methods: {
    scrollTo(section) {
      this.drawer = false;
      const element = document.getElementById(section);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    openContact() {
      this.contactDialog = true;
    },
    submitForm() {
      alert(
        "Thank you! We have received your corporate inquiry and will contact you within 2 business hours.",
      );
      this.contactDialog = false;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap");

.scroll-wrapper {
  position: relative;
  width: 100%;
  height: auto;
  overflow-x: hidden;
}

.hero-sticky-wrapper {
  position: sticky;
  top: 0;
  height: auto;
  z-index: 1;
  overflow: hidden;
}

.scroll-content {
  position: relative;
  z-index: 2;
  background: #fff;
}

.v-application {
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif !important;
}

html {
  scroll-behavior: smooth;
}

.nav-btn-modern {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #000 !important;
  letter-spacing: 0 !important;
  transition: color 0.2s ease;
}
.nav-btn-modern:hover {
  color: #f46523 !important;
}
.nav-btn-modern::before {
  background-color: transparent !important;
}

.book-now-modern {
  transition: all 0.3s ease;
}
.book-now-modern:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(244, 101, 35, 0.3) !important;
}

.hero-modern {
  display: flex;
  align-items: center;
}
.min-vh-80 {
  min-height: 80vh;
}

.hero-title {
  animation: fadeInUp 0.8s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.service-card-modern:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1) !important;
  border-color: #f46523 !important;
}

.service-card-modern:hover .service-image-wrapper img {
  transform: scale(1.05);
}

.process-number {
  transition: all 0.3s ease;
}
.v-card:hover .process-number {
  background: #f46523 !important;
  color: white !important;
  transform: scale(1.1);
}

@media (max-width: 960px) {
  .hero-title {
    font-size: 2.5rem !important;
  }
}

@media (max-width: 600px) {
  .hero-title {
    font-size: 2rem !important;
  }

  .display-1 {
    font-size: 1.75rem !important;
  }
}

.v-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.v-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

::selection {
  background: #f46523;
  color: white;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #f46523;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: #d45420;
}

.v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #f46523 !important;
  border-width: 2px !important;
}

.v-text-field--outlined.v-input.v-label {
  color: #f46523 !important;
}

.v-footer .v-btn--text:hover {
  color: #f46523 !important;
}

.testimonial-card-modern {
  transition: all 0.3s ease;
}

img {
  display: block;
  max-width: 100%;
}
</style>
